import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';


const AssociateListTable = (props) => {

    const {
        index,
        service_attribute_association, 
        example,
        service_attribute_response
    } = props;


    let associationHtml = '';
    if(service_attribute_association.length > 0){
        associationHtml = service_attribute_association.map((associate, i) => (
            <span className="fs-7 fw-bold me-2 text-gray-600"  key={i}>
                <span className="text-gray-600 fw-bold fs-6">
                    {associate.value}
                </span>
            </span>
        ));
    }

    const associationDataDeleteOnClick = async (index) => {
        const associateDeleteSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if (associateDeleteSwal.isConfirmed) {
            props.serviceAttributeAssociationDelete(index)
        }
    }

    return(
        <>
            
            <tr
                // draggable
                // onDragStart={handleDragStart}
                // onDragOver={(e) => e.preventDefault()}
                // onDrop={handleDrop}
                // style={{
                //     cursor: "move",
                // }}
            >
                <td>
                    {associationHtml}
                </td>
                <td>
                    {example}
                </td>
                {/* <td>
                    { service_attribute_response ? service_attribute_response.label: '' }
                </td> */}
                <td className="d-flex float-end">
                    <div
                        className='cursor-pointer me-3' 
                        onClick={(e) => { e.preventDefault(); props.serviceAttributeUpdateOnClick(index) }}>
                        <FontAwesomeIcon icon={faPen} className='text-primary fs-3' />
                    </div>
                    <div
                        className='cursor-pointer'
                        onClick={(e) => { e.preventDefault(); associationDataDeleteOnClick(index)}} >
                        <FontAwesomeIcon icon={faTrash} className='text-danger fs-3' />
                    </div>
                </td>
            </tr>
        </>
    )
}

const ServiceAttributeAssociationList = (props) => {
    const { serviceAttributeAssData } = props;

    const [totalAssociationData, setTotalAssociationData] = useState([]);

    useEffect(() => {
        setTotalAssociationData(serviceAttributeAssData);
    }, [serviceAttributeAssData]);

    let associationHtml = '';
    if( totalAssociationData.length > 0 ){
        associationHtml = totalAssociationData.map((associate, i) => (
            <AssociateListTable
                key={i}
                index={i}
                service_attribute_association={associate.service_attribute_association}
                example={associate.example}
                service_attribute_response={associate.service_attribute_response}
                serviceAttributeAssociationDelete={props.serviceAttributeAssociationDelete}
                serviceAttributeUpdateOnClick={props.serviceAttributeAssUpdateOnClick}
            />
        ))
    }

    return (
        <>
            {
                totalAssociationData.length > 0 &&
                <>
                    <div className="separator border-gray-300 my-6"></div>
                    <div className="table-responsive">
                        <table className="table table-row-dashed align-middle gs-0 gy-4">
                            <thead className="border-gray-200 fs-5 fw-semibold bg-lighten">
                                <tr className='fs-7 fw-bold border-0 text-gray-400'>
                                    <th className="" style={{width:'250px'}}>Selected Association</th>
                                    <th className="" style={{width: '500px'}}>Example</th>
                                    {/* <th className="">Response</th> */}
                                    <th className=""></th>
                                </tr>
                            </thead>
                            <tbody className="fw-6 fw-semibold text-gray-600">
                                {associationHtml}
                            </tbody>
                        </table>
                    </div>
                </>
            }
        </>
    )
}

export default ServiceAttributeAssociationList